import LetterAvatar from "@/components/Avatar/LetterAvatar"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import StatusBadge from "@/components/ui/badge"
import CodeFormat from "@/components/ui/code"
import { formatToDevanagariStyle } from "@/utilities/helper"
export const columns = [
  {
    header: "Code",
    cell: ({ row }) => <CodeFormat value={row.original.code} />,
  },
  {
    header: "Sales Date",
    cell: ({ row }) => row.original.date,
  },
  {
    header: "Sales Date Nepali",
    cell: ({ row }) => row.original.date_nepali,
  },
  {
    header: "Total Amount",
    cell: ({ row }) =>
      `Rs. ${formatToDevanagariStyle(row.original.total_return_amount)}`,
  },
]
